import React, { Component } from 'react'
import GradesPV from './GradesPV'
import AuthA from '../../store/actions/AuthA'
import QuarterA from '../../store/actions/QuarterA'
import Papa from 'papaparse'

import axios from 'axios'
import sortBy from 'lodash/sortBy'
import find from 'lodash/find'
import constantCase from 'constant-case'
import paramCase from 'param-case'
import {connect} from 'react-redux'
import { getQuarterDbField, isValidQuarter } from '../../utils/quarterUtils'

const _ = {
    sortBy: sortBy,
    find: find
}

const changeCase = {
  constantCase: constantCase,
  paramCase: paramCase
}

class GradesPC extends Component {
  constructor(props) {
    super(props);
    this.state = {
      grades: [],
      section: [],
      sectionSubject: [],
      sectionSubjectId: '',
      column: null,
      direction: null,
      sectionStudents: [],
      error: false,
      success: false,
      fileName: '',
      gradeSheet: null,
      areGradesSaved: false,
      results: [],
      dirtyInput: false,
      open: false,
      created: [],
      checked: [],
      reviewed: [],
      subjects: []
    };
    this.getGrades = this.getGrades.bind(this);
    this.getSection = this.getSection.bind(this);
    this.getSectionStudents = this.getSectionStudents.bind(this);
    this.handleUpdateSectionSubjectDetails = this.handleUpdateSectionSubjectDetails.bind(this);
    this.handleSort = this.handleSort.bind(this);
    this.handleUploadFileChange = this.handleUploadFileChange.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleDataChange = this.handleDataChange.bind(this);
    this.handleDataSave = this.handleDataSave.bind(this);
  }

  getGrades(sectionSubjectId) {
    const { sectionStudents, quarter } = this.state;
    axios.get(process.env.REACT_APP_URL+'/grades?filter[where][active]=true&filter[where][sectionSubjectId]='+sectionSubjectId)
    .then(response => {
      this.setState({ grades: response.data}, () => {
        if (response.data.length !== 0) {
          sectionStudents.map((sectionStudent, key )=> {
            const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
            const studentVariable = changeCase.constantCase(studentName);
            const grade = _.find(response.data, {
              sectionStudentId: sectionStudent.sectionStudentId
            });
            // Get grade field based on current quarter
            const quarterField = getQuarterDbField(parseInt(quarter), 'grades');
            this.setState({[studentVariable]: grade != null ? grade[quarterField] : 0, areGradesSaved: true})
            return true;
          })
        } else {
          sectionStudents.map((sectionStudent, key )=> {
            const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
            const studentVariable = changeCase.constantCase(studentName);

            this.setState({[studentVariable]: 0, areGradesSaved: false})

            return true;
          })
        }
      });
    });
  }

  getSection(sectionId) {
    axios.get(process.env.REACT_APP_URL+'/sections?filter[where][active]=true&filter[where][sectionId]='+sectionId)
    .then(response => {
      this.setState({ section: response.data});
    });
  }

  getSectionSubject = (sectionSubjectId) => {
    axios.get(process.env.REACT_APP_URL+'/sectionSubjects?filter[where][active]=true&filter[include]=subject&filter[include]=details&filter[where][sectionSubjectId]='+sectionSubjectId)
    .then(async(response) => {
      await this.getSectionSubjectDetailsForChecking();
      await this.getSectionSubjectDetailsForReview();
      await this.getSectionSubjectDetailsForApproval();
      await this.getSubjects();
      this.setState({ sectionSubject: response.data});
    });
  }

  getSectionSubjectDetailsForChecking = async() => {
    await axios.get(process.env.REACT_APP_URL+`/sectionSubjectDetails?filter[where][active]=true&filter[include]=sectionSubject&filter[where][status]=Created&filter[where][type]=grade&filter[where][quarter]=${this.props.currentQuarter}`)
    .then(response => {
      this.setState({created: response.data})
    });
  }

  getSectionSubjectDetailsForReview = async() => {
    await axios.get(process.env.REACT_APP_URL+`/sectionSubjectDetails?filter[where][active]=true&filter[include]=sectionSubject&filter[where][status]=Checked&filter[where][type]=grade&filter[where][quarter]=${this.props.currentQuarter}`)
    .then(response => {
      this.setState({checked: response.data})
    });
  }

  getSectionSubjectDetailsForApproval = async() => {
    await axios.get(process.env.REACT_APP_URL+`/sectionSubjectDetails?filter[where][active]=true&filter[include]=sectionSubject&filter[where][status]=Reviewed&filter[where][type]=grade&filter[where][quarter]=${this.props.currentQuarter}`)
    .then(response => {
      this.setState({reviewed: response.data})
    });
  }

  getSubjects = async() => {
    await axios.get(process.env.REACT_APP_URL+'/subjects?filter[where][active]=true')
    .then(response => {
      this.setState({ subjects: response.data });
    });
  }

  getSectionStudents(sectionId) {
    axios.get(process.env.REACT_APP_URL+'/sectionStudents?filter[where][active]=true&filter[include]=student&filter[where][sectionId]='+sectionId)
    .then(response => {
      const sorted = _.sortBy(response.data, function(o){return [o.student.lastName, o.student.firstName]})
      this.setState({ sectionStudents: sorted }, () => {
        this.getGrades(this.state.sectionSubjectId);
      });
    });
  }

  handleUpdateSectionSubjectDetails(data, id) {
    const sectionSubjectDetail = _.find(this.state.sectionSubject[0].details, {
      quarter: parseInt(this.state.quarter),
      type: 'grade'
    });

    if (sectionSubjectDetail.status === 'To Do' || sectionSubjectDetail.status === 'Discarded' || sectionSubjectDetail.status === 'Resubmit') {
      let fileData = new FormData();
      fileData.append('filePath', this.state.gradeSheet);
      if (this.state.gradeSheet.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'){
        const uploadUrl = `${process.env.REACT_APP_URL}/containers/${process.env.REACT_APP_CONTAINER}/upload`;
        axios.request({
          method:'post',
          url:`${uploadUrl}`,
          data: fileData
        }).then(response => {
          console.log(response)
        }).catch(err => console.log(err));
      } else {
        alert('File extension must be xlsx. Please save your grade sheet in xlsx format.')
        this.setState({open: false})
        return
      }
    }

    const url = process.env.REACT_APP_URL+'/sectionSubjectDetails/'+id;
    axios
      .request({
        method: 'put',
        url: url,
        data: data
      })
      .then(response => {
        alert('The status of this subject was successfully updated.')
        this.setState({open: false}, this.getSectionSubject(this.state.sectionSubjectId))
      })
      .catch(err => console.log(err));
  }

  handleSort(clickedColumn) {
    const { column, sectionStudents, direction } = this.state
    if (column !== clickedColumn) {
      if(clickedColumn === 'name') {
        this.setState({
          column: clickedColumn,
          sectionStudents: _.sortBy(sectionStudents, function(o){return o.student.lastName}),
          direction: 'ascending',
        })
        return
      } else {
        this.setState({
          column: clickedColumn,
          sectionStudents: _.sortBy(sectionStudents, [clickedColumn]),
          direction: 'ascending',
        })
        return
      }
    }
    this.setState({
      sectionStudents: sectionStudents.reverse(),
      direction: direction === 'ascending' ? 'descending' : 'ascending',
    })
  }

  handleChange = (e, { name, value }) => {
    this.setState({[name]: value, dirtyInput: true})
  }

  handleApprovalOpen = () => {
    this.setState({
      open: true
    })
  }

  handleApprovalClose = () => this.setState({
    open: false
  })

  handleSubmit = () => {

    const {sectionStudents, sectionSubject, quarter} = this.state;

    // Validations
    let hasInvalidValue = sectionStudents.some((sectionStudent) => {
      const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
      const studentVariable = changeCase.constantCase(studentName);

      if(this.state[studentVariable] === undefined) {
        return true;
      }
      // handle for holding grades
      if(parseInt(this.state[studentVariable], 10) === 0) {
        return false;
      }

      return parseInt(this.state[studentVariable],10) < 70 || parseInt(this.state[studentVariable],10) > 100 || this.state[studentVariable] === ''
    });

    if (hasInvalidValue) {
      this.setState({error: hasInvalidValue, success: false})
    } else {
      sectionStudents.map((sectionStudent, key )=> {
        const studentName = sectionStudent.student.lastName +', '+sectionStudent.student.firstName;
        const studentVariable = changeCase.constantCase(studentName);

        // Get quarter field using centralized utility
        const quarterLabel = getQuarterDbField(parseInt(quarter), 'grades');
        const sectionSubjectId = sectionSubject[0].sectionSubjectId;
        const sectionStudentId = sectionStudent.sectionStudentId;
        const data = {
          sectionStudentId: sectionStudentId,
          sectionSubjectId: sectionSubjectId,
          [quarterLabel]:  this.state[studentVariable]
        }

        const url = process.env.REACT_APP_URL+'/grades/upsertWithWhere?where={"sectionSubjectId":"'+sectionSubjectId+'","sectionStudentId":"'+sectionStudentId+'"}';
        axios
          .request({
            method: 'post',
            url: url,
            data: data
          })
          .then(response => {
            this.getGrades(sectionSubjectId)
          })
          .catch(err => console.log(err));

        return true;
      })
      //Show next steps for the approval process
      this.setState({success: true, error: false, dirtyInput: false, open: true})
    }
  }

  handleUploadFileChange(gradeSheet) {
    const { sectionSubject, section, quarter } = this.state;

    const sectionSubjectDetail = _.find(this.state.sectionSubject[0].details, {
      quarter: parseInt(this.state.quarter),
      type: 'grade'
    });

    let fileName;
    if (sectionSubjectDetail.resubmitCount) {
      fileName = `${changeCase.paramCase(sectionSubject[0].subject.name)}-${changeCase.paramCase(section[0].name)}-grades-${quarter}(${sectionSubjectDetail.resubmitCount}).xlsx`;
    } else {
      fileName = `${changeCase.paramCase(sectionSubject[0].subject.name)}-${changeCase.paramCase(section[0].name)}-grades-${quarter}.xlsx`;
    }

    const newFileName = `2019-2020/${sectionSubject[0].subject.code}/${fileName}`;
    const file = new File([gradeSheet], newFileName, { type: gradeSheet.type });

    this.setState({gradeSheet: file, fileName: fileName});
  }

  handleFileChange(file) {
    const self = this;
    Papa.parse(file, {
      header: true,
      dynamicTyping: true,
      skipEmptyLines: true,
      complete: function(results) {
        self.handleDataChange(results)
    	}
    });
  }

  handleDataChange(results) {
    // this.handleDataSave(results.data);
    this.setState({results: results.data})
    console.log('Parsing complete:', results);
  }

  handleDataSave() {
    const data = this.state.results;
    const { sectionSubject, sectionStudents } = this.state;
    const quarter = this.props.currentQuarter;
    let parsedStudent = {};

    // Get quarter field using centralized utility
    const quarterLabel = getQuarterDbField(quarter, 'grades');

    const sectionSubjectId = sectionSubject[0].sectionSubjectId;

    for (let i = 0; i < data.length; i++) {

      // const firstName = data[i]['First Name'];
      // const lastName = data[i]['Last Name'];
      const studentNumber = data[i]['Student Number'];
      const grade = data[i]['Grades'];

      const student = _.find(sectionStudents, function(o) {
        return o.student.studentNumber === studentNumber
      });
      console.log(student)
      if (student != null) {
        parsedStudent = {
          sectionSubjectId: sectionSubject[0].sectionSubjectId,
          sectionStudentId: student.sectionStudentId,
          [quarterLabel]: grade
        }
      } else {
        alert('Error. Please contact your administrator for assistance.');
        return
      }

      const sectionStudentId = student.sectionStudentId;

      const url = process.env.REACT_APP_URL+'/grades/upsertWithWhere?where={"sectionSubjectId":"'+sectionSubjectId+'","sectionStudentId":"'+sectionStudentId+'"}';
      axios
        .request({
          method: 'post',
          url: url,
          data: parsedStudent
        })
        .then(response => {
          if (i === data.length-1) {
            this.setState({success: true}, () => this.getGrades(sectionSubjectId));
          }
        })
        .catch(error => {
          console.log(error)
          if (error.response) {
            alert(`${error.response.data.error.message}`);
          } else if (error.request) {
            alert(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            alert('Error. Please contact your administrator for assistance.');
          }
        });
    }
    alert('Grades successfully added!')
  }

  componentDidMount() {
    this.props.authFn.getToken()
    this.props.onContentMount({title:'Grades'});

    const sectionId = this.props.match.params.sectionId;
    const sectionSubjectId = this.props.match.params.sectionSubjectId;
    const params = new URLSearchParams(this.props.location.search);
    const quarter = params.get('quarter');
    
    // Update Redux quarter state if quarter is provided in URL
    if (quarter && isValidQuarter(parseInt(quarter))) {
      this.props.quarterActions.setCurrentQuarter(parseInt(quarter));
    }
    
    this.setState({sectionSubjectId: sectionSubjectId}, () => {
      this.getSectionStudents(sectionId);
      this.getSectionSubject(sectionSubjectId);
      this.getSection(sectionId);
    })

  }

  componentWillReceiveProps(newProps) {
    const sectionId = newProps.match.params.sectionId;
    const sectionSubjectId = newProps.match.params.sectionSubjectId;
    const params = new URLSearchParams(newProps.location.search);
    const quarter = params.get('quarter');
    
    // Update Redux quarter state if quarter is provided in URL
    if (quarter && isValidQuarter(parseInt(quarter))) {
      this.props.quarterActions.setCurrentQuarter(parseInt(quarter));
    }
    
    this.setState({sectionSubjectId: sectionSubjectId}, () => {
      this.getSectionStudents(sectionId);
      this.getSectionSubject(sectionSubjectId);
      this.getSection(sectionId);
    })

  }

  render() {
    return (
      <GradesPV
        auth={this.props.auth}
        username={this.props.username}
        userType={this.props.userType}
        userId={this.props.userId}
        column={this.state.column}
        direction={this.state.direction}
        section={this.state.section}
        sectionSubject={this.state.sectionSubject}
        sectionStudents={this.state.sectionStudents}
        error={this.state.error}
        success={this.state.success}
        quarter={this.props.currentQuarter}
        fileName={this.state.fileName}
        areGradesSaved={this.state.areGradesSaved}
        dirtyInput={this.state.dirtyInput}
        open={this.state.open}
        created={this.state.created}
        checked={this.state.checked}
        reviewed={this.state.reviewed}
        subjects={this.state.subjects}
        {...this.state}
        handleApprovalOpen={this.handleApprovalOpen}
        handleApprovalClose={this.handleApprovalClose}
        handleUpdateSectionSubjectDetails={this.handleUpdateSectionSubjectDetails}
        handleDataSave={this.handleDataSave}
        handleSort={this.handleSort}
        handleChange={this.handleChange}
        handleSubmit={this.handleSubmit}
        handleFileChange={this.handleFileChange}
        handleUploadFileChange={this.handleUploadFileChange}
      />
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authFn: AuthA(dispatch),
    quarterActions: QuarterA(dispatch)
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.AuthR.auth,
    username: state.AuthR.username,
    userType: state.AuthR.userType,
    userId: state.AuthR.userId,
    currentQuarter: state.QuarterR.currentQuarter,
    schoolYearId: state.QuarterR.schoolYearId
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(GradesPC);
